import { ApiEndpointHandler } from '@sonar-software/sonar-http';
import { DataSecurityApplicationStatus } from '@types';

import {
	patchDataSecurityApplicationById,
	PatchDataSecurityApplicationByIdRequest
} from './patchDataSecurityApplicationById';

export type unhideDataSecurityApplicationByIdRequest = Pick<PatchDataSecurityApplicationByIdRequest, 'applicationId'>;

export const unhideDataSecurityApplicationById: ApiEndpointHandler<unhideDataSecurityApplicationByIdRequest> =
	(request, options) => patchDataSecurityApplicationById({
		...request,
		status: DataSecurityApplicationStatus.Detected
	}, options);
